export const CONSTS = {
  ADD_ROUTE: $localize`Add Route`,
};
